"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("@airasia/phoenix-components/components/Theme/constant");

var _constants = require("./constants");

var _default = {
  PropTypes: {
    configObj: _propTypes.default.exact({
      showAll: _propTypes.default.exact({
        categoryTextMobile: _propTypes.default.string,
        categoryTextWeb: _propTypes.default.string,
        icon: _propTypes.default.string,
        label: _propTypes.default.string,
        productID: _propTypes.default.string
      }),
      productTileDetails: _propTypes.default.arrayOf(_propTypes.default.exact({
        productTile: _propTypes.default.string,
        iconUrl: _propTypes.default.string,
        showSearchWidget: _propTypes.default.string,
        redirectionUrl: _propTypes.default.string,
        newTab: _propTypes.default.string,
        attractText: _propTypes.default.string,
        position: _propTypes.default.string,
        gtmParameters: _propTypes.default.string,
        cnDisclaimerLine1: _propTypes.default.string,
        cnDisclaimerLine2: _propTypes.default.string,
        cnDisclaimerURL: _propTypes.default.string,
        redirectCompanyURL: _propTypes.default.string,
        redirectCompanyName: _propTypes.default.string,
        countDownTimer: _propTypes.default.string,
        adhocMessage: _propTypes.default.string,
        productID: _propTypes.default.string.isRequired,
        showSearchWidgetMobile: _propTypes.default.string,
        customPropertiesTile: _propTypes.default.object,
        dataToggleModal: _propTypes.default.string,
        toggleModal: _propTypes.default.string,
        productEvent: _propTypes.default.any
      })),
      gtmParameters: _propTypes.default.exact({
        event: _propTypes.default.string,
        eventCategory: _propTypes.default.string,
        eventActionClick: _propTypes.default.string,
        eventActionView: _propTypes.default.string,
        eventLabelView: _propTypes.default.string,
        eventLabelCardClick: _propTypes.default.string,
        eventLabelHeadlineClick: _propTypes.default.string
      }),
      enableGtm: _propTypes.default.string
    }),
    fireGtm: _propTypes.default.func,
    gtmConsumerName: _propTypes.default.string,
    background: _propTypes.default.oneOf(_constant.ARR_BACKGROUND_COLORS),
    textColor: _propTypes.default.oneOf(_constant.ARR_COLORS),
    highlightTileByDeFaultId: _propTypes.default.string,
    queryParamsPresent: _propTypes.default.bool,
    isIE: _propTypes.default.bool,
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    device: _propTypes.default.oneOf(Object.values(_constants.DEVICE_TYPE)),
    widgetFunction: _propTypes.default.func,
    zIndex: _propTypes.default.number,
    version: _propTypes.default.string,
    dynamicOrdering: _propTypes.default.bool,
    sessionKey: _propTypes.default.string,
    singleRow: _propTypes.default.bool,
    tileItemFlexDirection: _propTypes.default.string,
    tileItemSingleRowGridColumns: _propTypes.default.string,
    tileImageDesktopWidth: _propTypes.default.string,
    tileImageDesktopHeight: _propTypes.default.string,
    tileImageMobileWidth: _propTypes.default.string,
    tileImageMobileHeight: _propTypes.default.string
  },
  defaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    fireGtm: function fireGtm() {},
    gtmConsumerName: null,
    highlightTileByDeFaultId: null,
    queryParamsPresent: false,
    version: 'v1',
    dynamicOrdering: false,
    sessionKey: 'en-gb',
    singleRow: false
  }
};
exports.default = _default;